import React, { useEffect, useState, createContext, ReactNode } from "react";
import { getAuth, onAuthStateChanged, User } from "firebase/auth";
import {firebaseApp} from "../libs/firebase"


interface AuthContextType {
  currentUser: User | null | { uid: string };
}

interface AuthProviderProps {
  children: ReactNode;
  uid?: string;
}

export const AuthContext = createContext<AuthContextType>({ currentUser: null });

export const AuthProvider: React.FC<AuthProviderProps> = ({ children, uid }) => {
  const [currentUser, setCurrentUser] = useState<User | null | { uid: string }>(null);
  const [pending, setPending] = useState<boolean>(true);

  useEffect(() => {
    if (!firebaseApp) return;
    if (!uid) {
      onAuthStateChanged(getAuth(firebaseApp as any), (user) => {
        setCurrentUser(user);
        setPending(false);
      });
    } 
    else {
      const user = { uid: uid };
      setCurrentUser(user);
      setPending(false);
    }
  }, [uid, firebaseApp]);

  if (pending) {
    return <>Loading...</>;
  }

  return (
    <AuthContext.Provider
      value={{ currentUser:currentUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};
